/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */
import ApiClient from "./apiClient";
import { NavigateFunction } from "react-router";

export const toCheckout = async (orderId: string, navigate: NavigateFunction) => {
  try {
    const response = await ApiClient.get("/checkout?orderId=" + orderId);
    if (response.redirectUri) {
      navigate(response.redirectUri);
    }
  } catch (error) {
    console.error(error);
    navigate("/servicewelt");
  }
};
